(() => {
  const normalise = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('nl');
  const thumbnail = source => {
    try {
      const url = new URL(source, location.origin);
      if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', '220');
      return url.href;
    } catch { return source; }
  };
  const mount = (root, assets, change) => {
    const controls = root.querySelector('[data-illustration-controls]');
    if (!controls) return null;
    const search = controls.querySelector('[data-illustration-search]');
    const category = controls.querySelector('[data-illustration-category]');

    const seenSources=new Set();assets=window.BBBackgrounds.sort(assets).filter(a=>{const key=a.src?new URL(a.src,location.origin).pathname:a.id;if(seenSources.has(key))return false;seenSources.add(key);return true;});
    const count = controls.querySelector('[data-illustration-count]');
    for (const name of [...new Set(assets.flatMap(asset => asset.categories || [asset.category]).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'nl'))) {
      const option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      category.append(option);
    }
    search.addEventListener('input', change);
    category.addEventListener('change', change);
    return {
      filter() {
        const term = normalise(search.value).trim();
        const results = assets.filter(asset => (!category.value || (asset.categories || [asset.category]).includes(category.value)) && (!term || normalise([asset.label, asset.category, ...(asset.aliases || [])].join(' ')).includes(term)));
        count.textContent = results.length === 1 ? count.dataset.one : count.dataset.template.replace('[count]', String(results.length));
        return results;
      }
    };
  };
  window.BBIllustrations = { normalise, thumbnail, mount };
})();


